module.exports = __webpack_public_path__ + "img/za.ff62a8c5.svg";